import { useState, useEffect, useRef } from 'react'
import { builder } from '@builder.io/react'

export default function useBuilderContent(model, userAttributes) {
  const [builderContent, setBuilderContent] = useState(null)
  const [error, setError] = useState(null)
  const [isFetching, setIsFetching] = useState(true)
  const builderSubscription = useRef()

  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    async function fetchBuilderContent() {
      try {
        setIsFetching(true)
        setError(null)

        const data = await builder.get(model).promise()
        setBuilderContent(data)
      } catch (err) {
        setError(err)
      } finally {
        setIsFetching(false)
      }
    }

    fetchBuilderContent()

    if (
      userAttributes &&
      Object.values(userAttributes).length > 0 &&
      builder.userAttributesChanged
    ) {
      builder.setUserAttributes(userAttributes)
    }

    builderSubscription.current = builder.userAttributesChanged.subscribe(fetchBuilderContent)

    return () => {
      builderSubscription.current?.unsubscribe()
    }
  }, [model, JSON.stringify(userAttributes)])
  /* eslint-disable react-hooks/exhaustive-deps */

  return { builderContent, error, isFetching }
}
